import React, { useState } from "react";
import Circle from "../imgs/plus.svg";

const FaqItem = ({ title, subtitle, subtitle2 }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-3">
      <div
        className="border border-white rounded py-2 px-3 cursor-pointer flex items-center justify-between"
        onClick={() => setOpen(!open)}
      >
        <p className="text-white">{title}</p>
        <img src={Circle} height={40} width={40} />
      </div>

      {open && (
        <div className="border border-white border-t-0 p-3">
          <p className="text-white font-light text-sm">{subtitle}</p>
          <p className="text-white font-light text-sm mt-2">{subtitle2}</p>
        </div>
      )}
    </div>
  );
};

export default FaqItem;
